import React from 'react';
import RomanianPackage from '../languages/RomanianPackage';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { submitInsertForm } from '../actionCreators/submitInsertForm';
import { getOptions } from '../actionCreators/getOptions';
import FieldBuilder from './FieldBuilder';

class SubFormBuilder extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            hideForm: true
        }

        this.handleToggle = this.handleToggle.bind(this);
        this.submitData = this.submitData.bind(this);

    }

    componentDidMount() {

        if (this.props.view.formOptions) {
            this.props.getOptions(this.props.view.formOptions);
        }
    }

    handleToggle() {

        this.setState({ hideForm: !this.state.hideForm });
    }

    submitData(e) {

        e.preventDefault();

        var phpFile = this.props.view.phpSubtype + this.props.rowId;

        this.props.formData.activityId = this.props.rowId;

        let phpPath = this.props.view.subFormInsert;
        let formData = JSON.stringify(this.props.formData);

        this.props.submitInsertForm(phpPath, formData, this.props.view, phpFile);

    }

    render() {

        if (this.props.subFields) {

            return (
                <div>
                    <button onClick={this.handleToggle}>
                        {RomanianPackage.ADD}
                    </button>

                    <form
                        hidden={this.state.hideForm}
                        onSubmit={this.submitData}
                        id='insertForm'
                    >
                        {this.props.subFields.map(
                            function (field, index) {
                                return <FieldBuilder field={field} index={index} key={index} />
                            }
                        )}
                        <input type="submit" value={RomanianPackage.SUBMIT} />
                    </form>
                </div>
            )
        }
        else {

            return <div />
        }


    }
}

function mapStateToProps(state) {

    return {
        subFields: state.activeOption.subFormLabels,
        view: state.activeOption,
        formData: state.formData,
        subData: state.subTable.subData,
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        submitInsertForm: submitInsertForm,
        getOptions: getOptions
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(SubFormBuilder);


// WEBPACK FOOTER //
// ./src/formBuilder/SubFormBuilder.js